var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758159424457,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 89680,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.2 665.6c226.2016 0 358.4-101.0176 358.4-179.2 0-45.5168-62.1056-98.7648-158.6688-135.3216 10.9056-45.3632 7.68-35.1232 23.6544-94.3616C929.3312 313.6512 1024 407.4496 1024 486.4c0 122.88-229.2224 281.6-512 281.6 29.184-51.2 26.9824-59.1872 51.2-102.4z m-156.2112 95.0272C174.592 727.7568 0 591.9232 0 486.4 0 365.4656 229.2224 204.8 512 204.8c35.1744 0 69.5808 2.4576 102.7584 7.0144 26.2144 3.584 30.6176 106.8032 7.168 103.3728C586.9568 310.0672 550.0928 307.2 512 307.2 285.7984 307.2 102.4 409.4464 102.4 486.4c0 65.3824 132.352 148.992 310.8352 172.6976 2.1504 43.776-4.6592 59.4432-6.2464 101.5296z",
    "p-id": 89681
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M569.1392 606.3104A204.8512 204.8512 0 0 0 716.8 409.6c-33.5872 53.4528-105.0112 145.9712-147.6608 196.7104z m-104.96 2.4576a204.8 204.8 0 1 1 202.5472-333.3632c14.08 16.2304-187.1872 337.0496-202.5472 333.3632z",
    "p-id": 89682
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.7424 522.3936c-51.7632-15.5648-86.0672-70.0928-72.96-125.3376 13.1072-55.296 78.3872-86.528 123.904-72.8576-60.9792 37.3248-70.2464 67.328-75.2128 85.8624-4.9664 18.5856-12.032 45.7728 24.2688 112.3328z",
    fill: "#FFFFFF",
    "p-id": 89683
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M638.6176 131.2768l88.6784 51.2-386.6624 669.696-88.6784-51.2 386.6624-669.696z",
    "p-id": 89684
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseeye);
export default __webpack_public_path__ + "static/media/closeeye.1fd6a6eb.svg";
export { ForwardRef as ReactComponent };